import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

export const loadInvoiceServices = async () => {
  const { default: saleApi } = await import("../../../services/sale.service");
  return saleApi.invoiceServices();
};

const InvoiceServicePicker = ({ loadServices = loadInvoiceServices, onSelect, onCancel }) => {
  const [query, setQuery] = useState("");
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let current = true;
    Promise.resolve().then(() => loadServices()).then((response) => {
      if (!current) return;
      if (!Array.isArray(response?.data?.data)) throw new Error("Invalid service list");
      setServices(response.data.data.flatMap((group) => group.services || []));
    }).catch(() => { if (current) setError("Unable to load services. Please close and try again."); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [loadServices]);
  const matches = services.filter((service) => service.name.toLowerCase().includes(query.trim().toLowerCase()));
  return <section className="border rounded p-3 my-3" aria-label="Choose catalogue service">
    <label htmlFor="invoice-service-search">Search services</label>
    <input id="invoice-service-search" className="form-control" value={query} onChange={(event) => setQuery(event.target.value)}
      onKeyDown={(event) => { if (event.key === "Enter") event.preventDefault(); }} />
    {loading && <p role="status">Loading services…</p>}
    {error && <p role="alert">{error}</p>}
    {!loading && !error && !matches.length && <p>No matching services.</p>}
    <div className="list-group my-2">{matches.map((service) => {
      const prices = (service.serviceprice || []).filter((price) => price.price != null && Number.isFinite(Number(price.price)) && Number(price.price) >= 0);
      return prices.length ? prices.map((price) => <button key={`${service.id}-${price.id}`} type="button"
        className="list-group-item list-group-item-action" onClick={() => onSelect({ ...service, price: Number(price.price) })}>
        {service.name} — {Number(price.price).toFixed(2)}
      </button>) : <p key={service.id}>{service.name} — No price available</p>;
    })}</div>
    <button type="button" className="btn btn-link" onClick={onCancel}>Cancel service selection</button>
  </section>;
};
InvoiceServicePicker.propTypes = { loadServices: PropTypes.func, onSelect: PropTypes.func.isRequired, onCancel: PropTypes.func.isRequired };
export default InvoiceServicePicker;
